import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService } from '@shared/services';
import { AgentRunThread } from './cipo-ai.component';

export interface AiChatContextSelection {
  restrictToCurrentContext?: boolean;
  programEntityInstanceId?: number;
  projectEntityInstanceId?: number;
  contractEntityInstanceId?: number;
}

@Injectable({ providedIn: 'root' })
export class CipoAiService {
  private http = inject(HttpService);

  askQuestion(threadId: string, text: string, contextSelection?: AiChatContextSelection): Observable<AgentRunThread> {
    return this.http.post<AgentRunThread>(
      `_api/ai-chat/ask-question`,
      { threadId, text, contextSelection },
      { useLoader: false },
    );
  }

  getThreads(): Observable<AgentRunThread[]> {
    return this.http.get<AgentRunThread[]>(`_api/ai-chat/threads`, { useLoader: false });
  }

  getThread(threadId: string): Observable<AgentRunThread> {
    return this.http.get<AgentRunThread>(`_api/ai-chat/threads/${threadId}`, { useLoader: false });
  }

  deleteThread(threadId: string): Observable<AgentRunThread> {
    return this.http.delete<AgentRunThread>(`_api/ai-chat/threads/${threadId}/delete`, { useLoader: false });
  }
}
